module.exports = __webpack_public_path__ + "static/media/air2.d91e1983.jfif";